import { render, staticRenderFns } from "./GeoCountryBanner.vue?vue&type=template&id=53580a22"
import script from "./GeoCountryBanner.vue?vue&type=script&lang=js"
export * from "./GeoCountryBanner.vue?vue&type=script&lang=js"
import style0 from "./GeoCountryBanner.vue?vue&type=style&index=0&id=53580a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports